import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { PageHeader, CustomPanel, CustomCheckbox, Loading } from '../../../../components'
import Modal from './ModalGrupoUsuario'
import { showMessageBox } from '../../../../store/actions/system.actions'
import * as GrupoHttp from '../../../../services/api/https/settings/group.http'

class GrupoUsuario extends Component {
  state = {
    isLoanding: true,
    grupos: [],
    modal: {
      show: false,
      data: { id: null, name: '', actived: false },
    },
  }
  onBtnNovo = () => this._toggleModal(true)

  onModalClose = () => this._toggleModal(false)

  onModalSave = grupo => {
    this.setState(state => {
      const { grupos } = state
      const index = grupos.findIndex(l => l.id === grupo.id)
      index !== -1 ? (grupos[index] = grupo) : grupos.push(grupo)
      return { grupos, modal: this._resetModal() }
    })
  }
  onBtnVoltar = () => {
    this.props.history.goBack()
  }
  onRowClicked = grupo => {
    const { id, name, actived } = grupo
    this.setState({
      modal: {
        show: true,
        data: { id, name, actived },
      },
    })
  }
  componentDidMount = async () => {
    try {
      const grupos = await GrupoHttp.getGroups()
      this.setState({ isLoanding: false, grupos })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error))
    }
  }
  render() {
    const {
      isLoanding,
      modal: { show, data },
    } = this.state
    return (
      <div>
        <PageHeader>S.1 - Gestão Grupo de Usuários</PageHeader>
        <div style={{ marginTop: 20 }}>
          <CustomPanel onNovo={this.onBtnNovo} onVoltar={this.onBtnVoltar}>
            {isLoanding ? (
              <div className="text-center">
                <Loading size="md" />
              </div>
            ) : (
              this._dataTable()
            )}
          </CustomPanel>
        </div>
        {show ? (
          <Modal
            show={show}
            onModalClose={this.onModalClose}
            onModalSave={this.onModalSave}
            data={data}
          />
        ) : null}
      </div>
    )
  }

  _resetModal = () => {
    return {
      show: false,
      data: { id: null, name: '', actived: false },
    }
  }
  _toggleModal = show => {
    this.setState({ modal: { show } })
  }
  _dataTable = () => {
    return (
      <DataTable
        value={this.state.grupos}
        selectionMode="single"
        onSelectionChange={e => this.onRowClicked(e.value)}
      >
        <Column field="name" header="Grupo" />
        <Column
          field="actived"
          header="Ativo"
          style={{ textAlign: 'center', width: 100 }}
          body={(rowData, column) => <CustomCheckbox disabled checked={rowData.actived} />}
        />
      </DataTable>
    )
  }
}
export default connect()(withRouter(GrupoUsuario))
